// import logo from './logo.svg';
import '../../App.scss';
import React, { useState, useEffect } from "react";
import Banner from './main-banner/Banner.js';
import Navbar from './header/Navbar.js';
import Powerfull from './powerfull/Powerfull.js';
import Multichain from './multichain/Multichain.js';
import Abstract from './abstract/Abstract.js';
import Focus from './focus/Focus.js';
import Aqua from './aqua/Aqua.js';
import Scale from './scale/Scale.js';




function Landing() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  return (
    <>
    <div style={{overflow : 'hidden'}}>
      <Navbar />
      <Banner />
      <Powerfull/>
      <Multichain/>
      <Abstract/>
      <Focus/>
      <Aqua/>
      <Scale/>
</div>
    </>
  );
}

export default Landing;